@if(loginDone) {
@if (!loginDisplay) {
<app-cf-button [type]="Button.Primary" (click)="loginPopup()">Sign In</app-cf-button>
} @else {
<app-cf-menu [user]="user" (menuSelected)="onMenuSelected($event)"></app-cf-menu>
}

@if (!isIframe) {
<router-outlet />
}
} @else {
<app-cf-loader [style]="Loader.Circles" [size]="Size.Large">
    <p>Please wait...</p>
</app-cf-loader>
}